import { Chip } from '@mui/material';
import { useMemo } from 'react';
import { UserRole } from '../../core/interfaces/user.interface';

interface Props {
  roles: UserRole;
}

function RoleChip(props: Props) {
  const { roles } = props;

  const color = useMemo(() => {
    if (roles.superAdmin) return 'secondary';
    if (!roles.superAdmin) return 'primary';
  }, [roles]);

  const label = useMemo(() => {
    if (roles.superAdmin) return 'Super Admin';
    if (!roles.superAdmin) return 'Usuario';
  }, [roles]);

  return (
    <Chip color={color} label={label?.toUpperCase()} size="small" />
  );
}

export default RoleChip;
